var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5 ml-2",staticStyle:{"position":"fixed","bottom":"0"}},_vm._l((_vm.allAlerts),function(alert,index){return _c('AlertMessage',{attrs:{"alert":alert,"index":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }